import HeroAbout from './about/script';
import HeroCaseStudy from './case-study/script';
import HeroContact from './contact/script';
import HeroHome from './home/script';
import HeroSignUp from './sign-up/script';
import HeroNewsDetail from './news-detail/script';
import HeroNewsLanding from './news-landing/script';

export default {
	[HeroAbout.selector]: HeroAbout,
	[HeroCaseStudy.selector]: HeroCaseStudy,
	[HeroContact.selector]: HeroContact,
	[HeroHome.selector]: HeroHome,
	[HeroSignUp.selector]: HeroSignUp,
	[HeroNewsDetail.selector]: HeroNewsDetail,
	[HeroNewsLanding.selector]: HeroNewsLanding
};
